/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from 'src/app/modules/core/store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-email-field',
    templateUrl: './email-field.component.html',
    styleUrls: ['./email-field.component.scss'],
    standalone: false
})
export class EmailFieldComponent implements DynamicField {
  valueForDisplay: string;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() set field(value: SchemaField) {
    this._field = value;
  }
  get field(): SchemaField {
    return this._field;
  }
  _field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  get document(): Document {
    return this.reader.document;
  }
  reader: DocumentReader;
  @Input() dataset: Dataset;
  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  _isError = false;

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  set value(val: string) {
    this._isError = false;

    if (!val) {
      val = '';
    }

    var commaDelimited = val?.split(',').length > 1;

    if ((commaDelimited && val?.split(';').length > 1) || (!commaDelimited && val?.split(',').length > 1)) {
      this._isError = true;
      return;
    }

    var emails = commaDelimited ? val?.split(',') : val?.split(';');
    var trimmedEmails = [];

    for (var email of emails) {
      if (email?.trim().length > 0) {
        const emailRegex =
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        this._isError = !emailRegex.test(email);
      }

      trimmedEmails.push(email);
    }

    if (trimmedEmails.length === 0) {
      val = '';
    } else {
      val = commaDelimited ? trimmedEmails?.join(',') : trimmedEmails?.join(';');
    }

    this.valueForDisplay = val || '---';
    this._value = val;
  }
  get value(): string {
    if (!this._value) {
      this._value = '';
    }

    return this._value;
  }
  get isError(): boolean {
    return this._isError;
  }
  _value: string;
  isReadOnly = false;

  constructor() {}

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }
}
